import axios from 'axios';

export async function loadSettings(table, fallback = {}) {
  try {
    const { data } = await axios.get('/api/admin/settings/table-keys', { params: { table } });
    return data?.columns ?? fallback;
  } catch (e) {
    console.warn(`Не удалось загрузить настройки для "${table}"`, e);
    return fallback;
  }
}

export async function saveSettings(table, columns) {
  try {
    await axios.post('/api/admin/settings/table-keys', { table, columns });
    return true;
  } catch (e) {
    console.error(`Не удалось сохранить настройки для "${table}"`, e);
    return false;
  }
}
